/**
 * Viveka Brand Logo – Enterprise Lockup
 *
 * Inline SVG data-URL from the official Viveka Logo Kit.
 * See: https://viveka-inc.github.io/viveka-website/logo-swipes.html
 */

function svgToDataUrl(svg: string): string {
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
}

// Enterprise Lockup (master dark text)
const ENTERPRISE_LOCKUP_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 48" width="180" height="48"><defs><radialGradient id="eg2" cx="78%" cy="22%" r="65%"><stop offset="0%" stop-color="#60A5FA"/><stop offset="50%" stop-color="#3B82F6"/><stop offset="100%" stop-color="#1E3A8A"/></radialGradient></defs><svg x="4" y="4" width="40" height="40" viewBox="0 0 120 120"><circle cx="60" cy="60" r="56" fill="url(#eg2)"/><path d="M26,26 L43,30 L58,78 L77,30 L96,24 L74,99 L48,99 Z" fill="white"/></svg><text x="56" y="32" font-family="Plus Jakarta Sans,sans-serif" font-weight="800" font-size="22.4" letter-spacing="-0.3" fill="#1E293B">Viveka</text><circle cx="142" cy="30" r="2.4" fill="#FBBF24"/></svg>`

export const enterpriseLockupLogo = svgToDataUrl(ENTERPRISE_LOCKUP_SVG)
